import React, { memo } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {Table} from 'antd'
import Query from 'components/shared/Query'

const addressSearchQuery = gql`
  query AddressSearch($partialStreetName: String!) {
    viewer {
      id
      cadastres(partialStreetName: $partialStreetName, first: 40) {
        edges {
          node {
            ... on Cadastre {
              id
              type
              street
              number
              postalCode
              postalArea
              knr
              bnr
              gnr
              location {
                lat
                lon
              }
            }
          }
        }
      }
    }
  }
`

const cadastreSearchQuery = gql`
  query CadastreSearch($kommunenr: Int!, $gardsnr: Int!, $bruksnr: Int!) {
    viewer {
      id
      cadastres(knr: $kommunenr, gnr: $gardsnr, bnr: $bruksnr, first: 100) {
        edges {
          node {
            id
            type
            street
            number
            postalCode
            postalArea
            location {
              lat
              lon
            }
          }
        }
      }
    }
  }
`

const columns = [{
  dataIndex: 'id',
  key: 'id',
  render: (text, data) => {
    const { isSelected, address } = data
    return (
      <div className={`result-entry ${isSelected ? 'selected' : ''}`}>
        <div>{address.street}</div>
        <div className="postal-area">{address.postalCode} {address.postalArea}</div>
      </div>
    )
  }
}]

const SearchResult = ({partialStreetName, cadastreId, onSelect, selectedAddress}) => {
  const query = partialStreetName ? addressSearchQuery : cadastreSearchQuery
  const variables = partialStreetName ? {
      partialStreetName,
    } : {
      kommunenr: parseInt(cadastreId.knr, 10),
      gardsnr: parseInt(cadastreId.gnr, 10),
      bruksnr: parseInt(cadastreId.bnr, 10)
    }

  return (
    <div className="address-result">
      <Query
        inlineError
        inlineLoading
        query={query}
        variables={variables}
      >
        {({getData, loading}) => {
          if (!loading) {
            const nodes = getData('viewer.cadastres.edges').map(e => {
              return {
                id: e.node.id, // for key prop
                address: e.node, 
                isSelected: !!selectedAddress && selectedAddress.id === e.node.id
              }
            })
            return (
              <Table
                dataSource={nodes}
                columns={columns}
                showHeader={false}
                rowKey="id"
                locale={{emptyText: <div className="no-hits">Ingen treff</div>}}
                onRow={(record, rowIndex) => ({
                  onClick: () => onSelect(record)
                })}
                pagination={{ pageSize: 8 }}
              />
            )
          }

          return null
        }}
      </Query>
    </div>
  )
}

SearchResult.propTypes = {
  partialStreetName: PropTypes.string,
  cadastreId: PropTypes.object,
  onSelect: PropTypes.func,
}

export default memo(SearchResult)
